import React from 'react';
import { Typography } from '@mui/material';

export const RowNameText = ({ text }: { text: string }) => {
  return <Typography sx={{ color: '#666666', fontWeight: 500 }}>{text || ''}</Typography>;
};
